export const environment = {
  production: true,
  // apiUrl: "https://stage-api.40p.co"
  apiUrl: "https://api.40p.co"
};
